/* eslint-disable import/no-anonymous-default-export */
import axios from "core/axios";

export default {
  getContactsPriceList: () => {
    return axios.get(`/payment/getContactsPriceList`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  buyContact: (id: number) => {
    return axios.put(`/payment/buyContacts?idContacts=${id}`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.accessToken}`,
        },
      });
  },
};
